(() => {
  const coordinateRequests = new Map();
  function distanceMiles(a, b) {
    const rad = value => value * Math.PI / 180;
    const latitude = rad(b[0] - a[0]);
    const longitude = rad(b[1] - a[1]);
    const h = Math.sin(latitude / 2) ** 2 + Math.cos(rad(a[0])) * Math.cos(rad(b[0])) * Math.sin(longitude / 2) ** 2;
    return 3958.7613 * 2 * Math.atan2(Math.sqrt(h), Math.sqrt(Math.max(0, 1 - h)));
  }
  function initializeEvents() {
    const input = document.getElementById('ryf-event-search');
    if (!input || input.dataset.ready) return;
    input.dataset.ready = 'true';
    const state = document.getElementById('ryf-event-state');
    const month = document.getElementById('ryf-event-month');
    const cards = [...document.querySelectorAll('[data-event-date]')];
    const sections = [...document.querySelectorAll('[data-event-month]')];
    const panel = document.querySelector('[data-zip-finder]');
    const zipInput = panel?.querySelector('input');
    const zipStatus = panel?.querySelector('[role="status"]');
    const zipButton = panel?.querySelector('[type="submit"]');
    let originZip = '';
    let distances = new Map();
    let requestVersion = 0;
    const businessToday = () => new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
    const today = new Date(businessToday() + 'T00:00:00');
    const cutoff = new Date(today); cutoff.setDate(cutoff.getDate() + 21);
    [...new Set(cards.map(c => c.dataset.eventState))].sort().forEach(s => state.add(new Option(s, s)));
    sections.forEach(s => month.add(new Option(s.querySelector('h2').textContent, s.dataset.eventMonth)));
    cards.forEach(c => {
      const date = new Date(c.dataset.eventDate + 'T00:00:00');
      const featured = c.querySelector('[data-featured]');
      if (featured) featured.hidden = !(date >= today && date < cutoff);
    });
    function filter() {
      const q = input.value.trim().toLowerCase();
      let count = 0;
      cards.forEach(c => {
        const upcoming = /^\d{4}-\d{2}-\d{2}$/.test(c.dataset.eventDate || '') && c.dataset.eventDate >= businessToday();
        const withinRadius = !originZip || (distances.has(c) && distances.get(c) <= 100);
        c.hidden = !(upcoming && withinRadius && (!q || c.dataset.eventSearch.toLowerCase().includes(q)) && (!state.value || c.dataset.eventState === state.value) && (!month.value || c.dataset.eventDate.startsWith(month.value)));
        if (!c.hidden) count++;
      });
      sections.forEach(s => { s.hidden = ![...s.querySelectorAll('[data-event-date]')].some(c => !c.hidden); });
      document.getElementById('ryf-event-count').textContent = String(count);
      document.getElementById('ryf-event-empty').hidden = count > 0;
      if (originZip) {
        const message = count ? panel.dataset.zipResults.replace('[count]', String(count)) : panel.dataset.zipNone;
        zipStatus.textContent = (count === 1 ? message.replace('event dates', 'event date') : message).replace('[zip]', originZip);
        if (distances.size < cards.length) zipStatus.textContent += ' ' + panel.dataset.zipUnlocated;
      }
    }
    function clearRadius() {
      requestVersion++;
      originZip = '';
      distances.clear();
      if (zipInput) { zipInput.value = ''; zipInput.removeAttribute('aria-invalid'); }
      if (zipStatus) zipStatus.textContent = '';
      if (zipButton) zipButton.disabled = false;
      cards.forEach(card => card.querySelector('[data-event-distance]')?.remove());
    }
    panel?.querySelector('form').addEventListener('submit', async event => {
      event.preventDefault();
      const entered = zipInput.value.trim();
      const zip = /^\d{5}(?:-\d{4})?$/.test(entered) ? entered.slice(0, 5) : '';
      const version = ++requestVersion;
      if (!zip) { zipInput.setAttribute('aria-invalid', 'true'); zipStatus.textContent = panel.dataset.zipInvalid; zipInput.focus(); return; }
      zipInput.removeAttribute('aria-invalid');
      zipButton.disabled = true;
      zipStatus.textContent = panel.dataset.zipLoading;
      try {
        const eventZips = cards.map(card => {
          const matches = card.querySelector('.event-address')?.textContent.match(/\b\d{5}(?:-\d{4})?\b/g);
          return matches?.at(-1)?.slice(0, 5);
        }).filter(Boolean);
        const prefixes = [...new Set([zip[0], ...eventZips.map(value => value[0])])];
        const chunks = await Promise.all(prefixes.map(prefix => {
          if (!coordinateRequests.has(prefix)) {
            const request = fetch(panel.dataset['zipData' + prefix]).then(response => {
              if (!response.ok) throw new Error('ZIP lookup unavailable');
              return response.json();
            }).catch(error => { coordinateRequests.delete(prefix); throw error; });
            coordinateRequests.set(prefix, request);
          }
          return coordinateRequests.get(prefix);
        }));
        const coordinates = Object.assign({}, ...chunks);
        if (version !== requestVersion) return;
        if (!coordinates[zip]) { zipInput.setAttribute('aria-invalid', 'true'); zipStatus.textContent = panel.dataset.zipUnknown; return; }
        originZip = zip;
        distances = new Map();
        input.value = ''; state.value = ''; month.value = '';
        cards.forEach(card => {
          const venueAddress = card.querySelector('.event-address')?.textContent || '';
          const matches = venueAddress.match(/\b\d{5}(?:-\d{4})?\b/g);
          const eventZip = matches?.at(-1)?.slice(0, 5);
          card.querySelector('[data-event-distance]')?.remove();
          if (!coordinates[eventZip]) return;
          const distance = distanceMiles(coordinates[zip], coordinates[eventZip]);
          distances.set(card, distance);
          const badge = document.createElement('p');
          badge.className = 'ryf-event-distance'; badge.dataset.eventDistance = '';
          badge.textContent = panel.dataset.zipDistance.replace('[miles]', String(Math.round(distance)));
          card.querySelector('.event-address')?.parentElement.append(badge);
        });
        filter();
      } catch {
        if (version === requestVersion) zipStatus.textContent = panel.dataset.zipFailed;
      } finally {
        if (version === requestVersion) zipButton.disabled = false;
      }
    });
    panel?.querySelector('[data-zip-reset]').addEventListener('click', () => {
      clearRadius(); input.value = ''; state.value = ''; month.value = ''; filter();
    });
    zipInput?.addEventListener('input', () => {
      requestVersion++;
      zipInput.removeAttribute('aria-invalid');
      zipButton.disabled = false;
      if (!zipInput.value.trim()) { clearRadius(); filter(); }
    });
    input.addEventListener('input', filter); state.addEventListener('change', filter); month.addEventListener('change', filter); filter();
  }
  // Keep explicit new-tab booking links from being intercepted by the global popup.
  function initializeBookingLinks() {
    document.querySelectorAll('a[href*="calendly.com"][target="_blank"]').forEach(link => {
      if (link.dataset.ryfNewTabReady) return;
      link.dataset.ryfNewTabReady = 'true';
      link.addEventListener('click', event => event.stopPropagation());
    });
  }
  initializeBookingLinks();
  document.addEventListener('shopify:section:load', initializeBookingLinks);
  initializeEvents();
  document.addEventListener('shopify:section:load', initializeEvents);
})();
